import React from 'react';
import PropTypes from 'prop-types';

import Script from 'react-load-script';
import stringReplace from 'react-string-replace';
import { Helpers } from '../../../core/src/helpers';
import withPrices from '../../../product/components/product-price/with-product-price';


import '../../css/features-tab-content.less';


class FeaturesTabContent extends React.Component {

    static propTypes = {
        sku: PropTypes.string.isRequired,
        content: PropTypes.object.isRequired,
        prices: PropTypes.object,
        fetchPrices: PropTypes.func
    };

    state = {
        value: ""
    }

    componentDidMount(){
        this.fetchPrices(this.props.content.html);
        this.setStringWithPrice(this.props.content.html);
    }

    componentDidUpdate(prevProps){
        if(this.props.prices !== prevProps.prices){
            this.setStringWithPrice(this.props.content.html);
        }
        if(this.props.sku !== prevProps.sku){
            this.fetchPrices(this.props.content.html);
        }
    }

    fetchPrices = (value) => {
        let matches;
        let ids=[];
        let skus = [];
        const regexp = RegExp(/\{itemId\:(\d+)\,sku\:([^}]*)/g);
        while ((matches = regexp.exec(value)) !== null) {
            ids.push(matches[1]);
            skus.push(matches[2]);
        }
        //checking if prices were previously fetched
        let pricesFetched = true;
        skus.forEach((sku)=>{
            if(!this.props.prices[sku]) pricesFetched = false;
        });
        //if pricesFetched, setting the string otherwise, fetching prices
        if(pricesFetched) this.setStringWithPrice(value);
        else this.props.fetchPrices(ids);
    }

    setStringWithPrice = (string) => {
        let newValue = stringReplace(string, /(\{itemId\:\d+\,sku\:[^}]*\})/g, (match, i) => {
            const [ str, itemId, sku ] = match.match(/itemId\:(\d+)\,sku\:([^}]*)/);
            if(this.props.prices[sku]){
                const prdPrice = this.props.prices[sku];
                const [ numeralPrice, decimalPrice ] = prdPrice.salePrice.toString().split('.');
                return(
                    `<div class="standard_price">
                        <span class="price_info">
                            <span class="price_strike">${(prdPrice.regularPrice > prdPrice.salePrice) ? `${prdPrice.regularPrice}` : ''}</span>
                        </span>
                        <span class="price_amount"><sup >$</sup><span id="price_value" >${numeralPrice}.<sup>${decimalPrice}</sup></span></span>
                    </div>`
                )
            }else{
                return '<div class="standard_price"></div>';
            }
        })
        newValue = <span dangerouslySetInnerHTML={Helpers.createMarkup(newValue.join(''))}></span>
        this.setState({value: newValue});
    }

    render(){
        const { value } = this.state;
        const { content } = this.props;
        if(value){
            return (
                <div className='features-tab-component'>
                    { value }
                    {
                        content.scripts && content.scripts.map((script,i) =>
                            <Script
                                key={`script-${i}`}
                                url={script}
                            />
                        )
                    }
                </div>
            );
        }
        else return null;
    }
}
export default withPrices(FeaturesTabContent);
